
<select *ngIf="LeftMenu" [(ngModel)]="Query.main" (change)="LeftMenuSet()">
    <ng-container *ngFor="let item of LeftMenu">
        <option [value]="item.value">{{item.name}}</option>
    </ng-container>
</select>

<ng-container *ngIf="Query.main != 4 && Query.main != 5">
    <select class="{{ Query.select == '' ? 'unselect' : '' }}" [(ngModel)]="Query.select" (change)="SearchSubmit()">
        <option [value]="''">請選擇</option>
        <ng-container *ngFor="let item of LeftSecMenu">
            <option [value]="item.value">{{item.name}}</option>
        </ng-container>
    </select>
</ng-container>

<ng-container *ngIf="Query.main == 4 || Query.main == 5">
    <input type="text" name="select" [(ngModel)]="Query.select" placeholder="請輸入關鍵字" (keypress)="eventHandler($event.keyCode)"/>
</ng-container>